// extracted by mini-css-extract-plugin
export default {"companyRoutesWidget":"CompanyRoutesWidget_companyRoutesWidget__w688j","pagination":"CompanyRoutesWidget_pagination__cJ3Pn"};